// TODO: Import React module
import * as React from 'react';
import ReactPlayer from 'react-player/file';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// TODO: Import MUI module
import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import { MusicNote, } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import { ContentTitle, } from '../Common/TypographyTYH';
import BoxImage from '../Common/BoxImage';
import ListText from '../Common/ListText';
import StackImage from '../Common/StackImage';

const RenderStackImage = ({ coverage }) => (
    <StackImage onClick={() => { window.open(coverage.url) }} hover={true}>
        <iframe
            src={`${coverage.url}`}
            style={{ aspectRatio: '16/9', border: 0, width: '100%', height: '100%' }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={coverage.title}
        ></iframe>
        <Typography sx={{ alignItems: 'start', color: 'white', display: 'flex', gap: 1, mt: 1, }} variant="body1">
            <MusicNote sx={{ color: 'white' }} />
            {coverage.title}
        </Typography>
        <Typography
            dangerouslySetInnerHTML={{ __html: coverage.description }}
            sx={{ color: 'white', }}
            variant="body2"
        />
    </StackImage>
);

const Creation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Creation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const swipeItems = [{
        title: '夢中注定在一起',
        description: '2025-2026唱作願景全港中學生創作大賽入圍歌曲<br>創作：麥頌謙<br>演唱：麥頌謙，李坤然',
        url: 'https://www.youtube.com/embed/Ej8d_1WqYnE',
    },{
        title: '路口的風',
        description: '2025-2026唱作願景全港中學生創作大賽季軍歌曲<br>創作：李沂樂<br>演唱：鄭采寶，李坤然',
        url: 'https://www.youtube.com/embed/Rdmv6lga1w0',
    },{
        title: '溫柔記憶',
        description: '2025-2026唱作願景全港中學生創作大賽入圍歌曲<br>創作：吳希妍<br>演唱：吳希妍，梁綺喬，鄧宇希，黎卓霖',
        url: 'https://www.youtube.com/embed/FOJRg1BvpT0',
    }, {
        title: '回望舊時光',
        description: '2025-2026音樂比賽創作組冠軍<br>創作：楊穎翹<br>演唱：顏浩然',
        url: 'https://www.youtube.com/embed/upsC9lpfkgk',
    }, {
        title: '解鎖',
        description: '2025-2026音樂比賽創作組亞軍<br>創作：麥頌謙<br>演唱：顏浩然',
        url: 'https://www.youtube.com/embed/QoW1a5BAlbM',
    },
    {
        title: '星河夢',
        description: '曲：顏浩然<br>詞：賴曉藍<br>編：顏浩然',
        url: 'https://www.youtube.com/embed/5LghWE0x6vg',
    },];

    const items = [
        {
            Works: [
                {
                    Name: '風之子',
                    Description: ['創作：賴曉藍，顏浩然'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/風之子.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/風之子.jpg',
        },
        {
            Works: [
                {
                    Name: '纏',
                    Description: ['創作：黃柏銘'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/纏.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/纏.jpg',
        },
        {
            Works: [
                {
                    Name: 'The Treasure you should love',
                    Description: ['創作：司徒紀嵐校友'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/TheTreasureYouShouldLove.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/TheTreasureYouShouldLove.jpg',
        },
        {
            Works: [
                {
                    Name: '城市漫遊',
                    Description: ['創作：郭思潁，劉詩詠，郭雅雯，潘鎬賢'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/城市漫遊.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/城市漫遊.jpg',
        },
        {
            Works: [
                {
                    Name: '以恆毅力堅持',
                    Description: ['創作：梁鎮朗，陳子謙', '主唱：梁鎮朗，陳子謙，本校體育科老師，本校精英運動員，啦啦隊，及資訊日嘉賓'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/以恆毅力堅持.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/以恆毅力堅持.jpg',
        },
        {
            Works: [
                {
                    Name: '最有趣的事',
                    Description: ['曲、詞: 郭思潁/潘鎬賢/劉詩泳/郭雅雯'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/zui_you_qu_de_shi_20231128.mp3',
                },
            ],
            Image: null,
        },
        {
            Works: [
                {
                    Name: '告訴我，我聆聽',
                    Description: ['曲、詞: 司徒紀嵐'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/gao_su_wo_wo_ling_ting.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/gao_su_wo_wo_ling_ting.jpg',
        },
        {
            Works: [
                {
                    Name: '傳回',
                    Description: ['唱、曲詞創作: 呂依銘校友'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/chuen_wui.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/chuen_wui20230207.jpg',
        },
        {
            Works: [
                {
                    Name: '第九味',
                    Description: ['作曲: 庾鎧榮', '填詞: 姚煒銓'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/di_jiu_wei.mp4',
                    isVideo: true,
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/di_jiu_wei.jpg',
        },
        {
            Works: [
                {
                    Name: '美好的陽光',
                    Description: ['唱: 2021-2022年度鄧英喜合唱團', '曲詞創作: 劉珮娜/朱慧敏老師', '音樂: 顏浩然'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/beautiful_sunshine.mp3',
                },
                {
                    Name: '又到聖誕',
                    Description: ['唱: 2021-2022年度鄧英喜合唱團', '曲詞創作: 朱慧敏老師'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/christmas2022.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/beautiful_sunshine.jpg',
        },
        {
            Works: [
                {
                    Name: 'BETTER DAY',
                    Description: ['唱、曲詞創作: 顏浩然'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/better_day.mp3',
                },
                {
                    Name: 'Weather',
                    Description: ['唱、曲詞創作: 顏浩然'],
                    URL: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/weather.mp3',
                },
            ],
            Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Creation/better_day.jpg',
        },
    ];

    // TODO: Define event
    const theme = useTheme();

    // TODO: Return component
    return (
        <Stack className="SectionCreation" spacing={2} sx={{ m: 5 }}>
            <ContentTitle text={Text.MusicalWork.Creation[context.language]} />
            {/*<Box sx={{ maxWidth: '80vw' }}>
                <Swiper
                    autoplay={{ delay: 2500, disableOnInteraction: false, }}
                    slidesPerView={1}
                    spaceBetween={16}
                    pagination={{ clickable: true, }}
                    breakpoints={{
                        0: { slidesPerView: 1, spaceBetween: 16, },
                        600: { slidesPerView: 2, spaceBetween: 16, },
                        900: { slidesPerView: 3, spaceBetween: 16, },
                        //1536: { slidesPerView: 4, spaceBetween: 16, },
                    }}
                    modules={[Autoplay, Navigation, Pagination]}
                    navigation={false}
                    style={{ '--swiper-pagination-color': theme.palette.primary.main, paddingBottom: '36px', }}
                >
                    {swipeItems.map((item, i) => (
                        <SwiperSlide
                            key={i}
                            style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', }}
                        >
                            <RenderStackImage coverage={item} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>*/}
            <Grid container spacing={2} sx={{ mb: 2 }}>
                {swipeItems.map((item, i) => (
                    <Grid key={i} size={{ xs: 6, md: 4 }}>
                        <RenderStackImage coverage={item} />
                    </Grid>
                ))}
            </Grid>
            <Grid container spacing={2}>
                {
                    items.map((item, i) => (
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Card
                                key={i}
                                sx={{
                                    alignItems: 'center',
                                    backgroundColor: 'tertiary.main',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 1,
                                    justifyContent: 'start',
                                    p: 2
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', width: 1 }}>
                                    {
                                        item.Works.map((work, i) => (
                                            <CardContent key={i} sx={{ p: 1 }}>
                                                <Typography variant="h5">{work.Name}</Typography>
                                                <ListText
                                                    lines={work.Description}
                                                    sxIcon={{ color: 'tertiary.main' }}
                                                    sxText={{ color: 'text.secondary' }}
                                                />
                                                {
                                                    work.isVideo ?
                                                        <video width="100%" controls>
                                                            <source src={work.URL} />
                                                        </video> :
                                                        <ReactPlayer
                                                            controls={true}
                                                            width="100%"
                                                            height="80px"
                                                            url={work.URL}
                                                        />
                                                }
                                            </CardContent>
                                        ))
                                    }
                                </Box>
                                {item.Image && <BoxImage src={item.Image} sx={{ mt: 1, width: 1 }} />}
                            </Card>
                        </Grid>
                    ))
                }
            </Grid>
        </Stack>
    );
};
export default Creation;